import React from "react";
import { Card, Typography, List } from "antd";
const { Title } = Typography;

const InfoCard = ({ icon, title, content, style = {} }) => (
  <Card
    className="bg-light rounded-3 text-left"
    style={{
      height: "100%",
      backgroundColor: "#f5f7fa",
    }}
  >
    <Title level={5}>
      {icon && <span style={{ marginRight: "10px" }}>{icon}</span>}
      {title}
    </Title>
    <div
      className="overflow-y-auto"
      style={{
        maxHeight: '300px',
      }}
    >
      {Array.isArray(content) ? (
        <List
          style={style}
          size="small"
          dataSource={content}
          renderItem={(item) => <List.Item style={{ padding: "5px 0" }}>• {item}</List.Item>}
        />
      ) : (
        <div>{content}</div>
      )}
    </div>
  </Card>
);

export default InfoCard;
